import { Component, OnInit } from '@angular/core';
import {FacultyService} from "../../services/faculty.service";
import { Router, ActivatedRoute, ParamMap } from '@angular/router';
import 'rxjs/add/operator/switchMap';

@Component({
  selector: 'app-faculty',
  templateUrl: './faculty.component.html',
  styleUrls: ['./faculty.component.css', './mobile.style.css']
})
export class FacultyComponent implements OnInit {

  searchResult:any;
  queryy:boolean = false;

	displayedColumns = ['Name', 'School', 'Area', 'Email'];
  dataSource = this.searchResult;

  constructor(private facultyService: FacultyService) { }

  ngOnInit() {
  }



  // vishal:[{}] = [{}]
  search(query:any){
    this.queryy=true;
  	if (query != "") {
	  	this.facultyService.search(query).subscribe((result:any)=>{
	  		this.searchResult = result;
	  		this.dataSource = result;
        this.queryy = false;
      })
    }else{
	  		this.queryy = false;
  		this.searchResult = null;
  	}
  }

}



// WEBPACK FOOTER //
// ./src/app/components/faculty/faculty.component.ts